// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { buildHeaders } from "../../internal/headers.mjs";
import { multipartFormRequestOptions } from "../../internal/uploads.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Files extends APIResource {
    /**
     * Retrieve a file from a folder by ID.
     */
    retrieve(fileID, params, options) {
        const { folder_id, ...query } = params;
        return this._client.get(path `/v1/folders/${folder_id}/files/${fileID}`, { query, ...options });
    }
    /**
     * List paginated files associated with a data folder.
     */
    list(folderID, query = {}, options) {
        return this._client.getAPIList(path `/v1/folders/${folderID}/files`, (ArrayPage), {
            query,
            ...options,
        });
    }
    /**
     * Delete a file from a folder.
     */
    delete(fileID, params, options) {
        const { folder_id } = params;
        return this._client.delete(path `/v1/folders/${folder_id}/${fileID}`, {
            ...options,
            headers: buildHeaders([{ Accept: '*/*' }, options?.headers]),
        });
    }
    /**
     * Upload a file to a data folder.
     */
    upload(folderID, params, options) {
        const { duplicate_handling, name, ...body } = params;
        return this._client.post(path `/v1/folders/${folderID}/upload`, multipartFormRequestOptions({ query: { duplicate_handling, name }, body, ...options }, this._client));
    }
}
//# sourceMappingURL=files.mjs.map